// extracted by mini-css-extract-plugin
module.exports = {"drawer":"NavbarSlider_drawer__1JhWx","active":"NavbarSlider_active__-i5bn"};